import { EMPTY, timer } from 'rxjs';
import { Util } from './../_classes/util';
import { tap, take, catchError } from 'rxjs/operators';
import { ModalAlertaService } from './../shared/modal-alerta.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { BeneficioServidor } from './../_classes/beneficio-servidor';
import { Observable, Subject } from 'rxjs';
import { Component, OnInit, ViewChild } from '@angular/core';
import { RestService } from '../_servicos/rest.service';
import { ServidorService } from '../_servicos/servidor.service';
import { ModalAjudaService } from '../shared/modal-ajuda.service';
import { EnvService } from '../_servicos/env.service';
import { UtilLogAcessoSistema } from '../_classes/util-log-acesso-sistema';

@Component({
  selector: 'app-beneficio',
  templateUrl: './beneficio.component.html',
  styleUrls: ['./beneficio.component.scss'],
})
export class BeneficioComponent implements OnInit {
  private readonly recurso: string = 'beneficio';
  carregando = false;
  displayedColumns: string[] = [
    'ativo',
    'dtInicio',
    'tipoBeneficio.dsTipoBeneficio',
    'categoriaBeneficio.dsCategoriaBeneficio',
  ];

  erros$ = new Subject<boolean>();
  dataSource$: Observable<BeneficioServidor[]>;
  dataSource: MatTableDataSource<BeneficioServidor>;

  //@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  itensAjuda = [
    {
      titulo: 'Período',
      texto: 'Período no qual o benefício é concedido',
    },
    {
      titulo: 'Tipo',
      texto:
        'Tipo do benefício concedido, juntamente com o tipo de dependência',
    },
    {
      titulo: 'Categoria/Dependente',
      texto:
        'Categoria do benefício e também o nome do dependente quando o benefício for referente à ele',
    },
  ];

  private t: any;

  ngOnDestroy() {
    if (this.t) {
      this.t.unsubscribe();
    }
  }

  constructor(
    private service: RestService,
    private servService: ServidorService,
    private alertService: ModalAlertaService,
    private ajudaService: ModalAjudaService,
    private env: EnvService
  ) {}

  ngOnInit() {
    this.atualizar();
  }

  atualizar() {
    this.carregando = true;
    this.t = timer(20000).subscribe((v) => {
      if (this.carregando) {
        this.carregando = false;
        this.handleError(
          'Excedido tempo de carregamento (' + this.constructor.name + ')'
        );
      }
    });
    if (this.env.servidor) {
      this.listar();
    } else {
      this.servService.getServidorComFuncao2().then(() => this.listar());
    }
  }
  listar() {
    UtilLogAcessoSistema.registrarAcessoAoRecurso(
      this.recurso,
      this.env.servidor.idServidor,
      this.service
    );

    this.dataSource$ = this.service
      .listarBeneficio(this.env.servidor.idServidor)
      .pipe(
        tap((a) => this.executarAoCarregarDatasource(a)),
        take(1),
        catchError((e) => {
          this.handleError(e);
          return EMPTY;
        })
      );
  }

  sortingDataAccessor(item, property) {
    if (property.includes('.')) {
      return property.split('.').reduce((object, key) => object[key], item);
    }
    return item[property];
  }

  executarAoCarregarDatasource(x: BeneficioServidor[]) {
    this.dataSource = new MatTableDataSource<BeneficioServidor>(x);
    if (this.dataSource) {
      //this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.dataSource.sortingDataAccessor = this.sortingDataAccessor;
    }
    this.carregando = false;
  }

  periodo(dI: Date, dF: Date) {
    return Util.periodoMesAbreviado(dI, dF);
  }
  dataStr(d: Date) {
    return Util.dataMesAbrev(d);
  }

  aplicarFiltro(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  mostrarAjudaModal() {
    this.ajudaService.mostrar(this.itensAjuda, '');
  }

  handleError(e: any) {
    this.erros$.next(true);
    this.alertService.mostrarAlertaPerigo(
      'Erro, tente novamente mais tarde',
      e
    );
  }

  ativo(dI: Date, dF: Date): boolean {
    let retorno = false;
    // T: #4cd137 F: #dcdde1

    if (dI) {
      if (dF) {
        if (dF > new Date()) {
          retorno = true;
        }
      } else {
        retorno = true;
      }
    }
    return retorno;
  }
}
